export default __webpack_public_path__ + "static/media/How it works.3d0945fe.png";